import Vue from 'vue'
import store from './../../store'
import notificationService from './../notification'

export default () => {
  const token = store.state.auth.accessToken
  return Vue.$http.post('auth/refresh_token/', {token})
    .then((response) => {
      const token = response.data.token
      store.dispatch('auth/login', token)
      return token
    })
}


// WEBPACK FOOTER //
// ./src/services/auth/refreshToken.js